import React from 'react';
import moment from 'moment';

import HeartIcon from 'assets/images/customIcons/heartIcon';
import styled from 'styled-components';
import Caption from '@twicapp/ui/components/Caption';
import Link from '@twicapp/ui/components/legacy/Link';

const Container = styled.footer`
  background-color: ${({
    theme: {
      colors: {
        background: { primary },
      },
    },
  }) => primary};
  padding: 60px 20px 20px;
  text-align: center;
`;

const Description = styled(Caption)`
  display: block;
`;

const MiddleDotSeparator = () => <span> &#8226; </span>;

const Footer = ({ showCompanyPrivacyPolicy = false }) => (
  <Container>
    <Description>
      {'Made with '}
      <HeartIcon style={{ color: 'hotpink' }} />
      {' by Twic, Inc. ©'}
      {moment().year()}
      {showCompanyPrivacyPolicy ? (
        <>
          <MiddleDotSeparator />
          <Link target="_blank" href="https://aka.ms/dpn">
            Microsoft Data Privacy Notice
          </Link>
        </>
      ) : (
        <>
          <MiddleDotSeparator />
          <a
            href="https://twic.ai/privacy-and-terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' Privacy Policy '}
          </a>
        </>
      )}
    </Description>
  </Container>
);

export default Footer;
